import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/park/credential/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/park/credential/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/park/credential/remove', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/park/credential/submit', params, options);

export const update = (params, options) =>
  request.post('/api/park/credential/submit', params, options);
